// if (!customElements.get('accordion-item')) {
//   class AccordionItem extends customElements.get(
//     'dropdown-disclosure'
//   ) {
//     constructor() {
//       super();
//     }

//     connectedCallback() {
//       setTimeout(() => {
//         if (!this.hasAttribute('data-expanded')) {
//           this.querySelector('details').open = false;
//         }
//         this.init();
//       });
//     }
//   }

//   customElements.define('accordion-item', AccordionItem);
// }
/* accordion-item.js
 * One-open-at-a-time behaviour
 * ------------------------------------------------------------ */

if (!customElements.get('accordion-item')) {
  class AccordionItem extends customElements.get('dropdown-disclosure') {
    constructor() {
      super();
      this.detailsEl = this.querySelector('details');
    }

    connectedCallback() {
      setTimeout(() => {
        if (!this.hasAttribute('data-expanded')) {
          this.detailsEl.open = false;
        }
        this.init(); // Original dropdown-disclosure init
        this.bindSingleOpen();
      });
    }

    bindSingleOpen() {
      this.detailsEl.addEventListener('toggle', () => {
        const isOpen = this.detailsEl.open;

        // 1. Add or remove 'is-open' class for CSS animation
        this.detailsEl.classList.toggle('is-open', isOpen);

        // 2. Close all sibling accordions when this one opens
        if (!isOpen) return;

        const siblings = this.parentElement.querySelectorAll('accordion-item details[open]');
        siblings.forEach((el) => {
          if (el !== this.detailsEl) {
            el.classList.remove('is-open');
            el.open = false;
          }
        });
      });
    }
  }

  customElements.define('accordion-item', AccordionItem);
}
